import { useState } from "react";
import { Download } from "lucide-react";
import api from "../../utils/axiosInstance";
import { toast } from "../Toast/toast";
import { btn } from "./buttonStyles";

// Fetches a zip from `url` and saves it as `fileName`. Disabled while there is
// nothing to download, so the server's "No files found" is never the answer.
const DownloadZipButton = ({ url, fileName, disabled = false }) => {
  const [downloading, setDownloading] = useState(false);

  const handleClick = async () => {
    try {
      setDownloading(true);
      const response = await api.get(url, { responseType: "blob" });
      const href = window.URL.createObjectURL(response.data);
      const a = document.createElement("a");
      a.href = href;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(href);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Download zip error:", error);
      toast.error("Failed to download files as zip");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled || downloading}
      className={btn("primary", "sm")}
    >
      <Download className="w-4 h-4" />
      {downloading ? "Downloading..." : "Download as ZIP"}
    </button>
  );
};

export default DownloadZipButton;
